<div class="wetter_content_container">
  <div class="bericht-text-container">
    <h3>Headline</h3>
    {{bioWetterbericht?.headline}}
  </div>
  <div class="bericht-text-container">
    <h3>Text</h3>
    {{bioWetterbericht?.wx_text}}
  </div>
  <div class="bericht-text-container">
    <h3>Zustand</h3>
    {{bioWetterbericht?.zustand}}
  </div>
  <div class="bericht-text-container">
    <h3>Entwicklung</h3>
    {{bioWetterbericht?.entwicklung}}
  </div>
  <div class="bericht-text-container">
    {{bioWetterbericht?.footer}}
  </div>
</div>
